// Actions related to API calls for studies
import { batch } from "react-redux";
import axios from "axios";
import { serverURL, csiTypes, wifiEnabled } from "../../constants/constants";
import { viewIds } from "../../constants/componentMap";

// Import necessary calls from other files
import {
  setView,
  discardStudy,
  errorResponse,
  receiveProtocol,
  successResponse,
  toggleExportPdfDialog,
  toggleExportCsvDialog,
  warningResponse,
  toggleExportStudiesDialog,
  toggleSyncStudiesDialog,
  resetSaveStudy,
  toggleSaveDialog,
  toggleLoadDialog,
  setLocalFilepath,
} from "../../actions";
import { studyFixture } from "../../constants/Fixtures/studyFixture";

export function fetchLocalStudiesList() {
  return function (dispatch, getState) {
    let state = getState();
    let req = {
      credential: {
        username: state.userInfo.username,
        password: state.userInfo.password,
      },
      localFolderpath: state.availableStudies.localFolderpath,
    };
    console.log("POST request made for /get_local_studies_list", req);
    dispatch(requestLocalStudiesList());

    // return axios.post(serverURL + "/get_local_studies_list", req).then(
    //   (response) => {
    //     console.log("get_local_studies_list", response);
    // dispatch(receiveLocalStudiesList(response.data));
    // dispatch(setLocalFilepath(null));
    //   },
    //   (error) => {
    //     dispatch(resetLocalStudiesList());
    //     dispatch(errorResponse(error));
    //   }
    // );
  };
}

export const REQUEST_LOCAL_STUDIES_LIST = "REQUEST_LOCAL_STUDIES_LIST";
export function requestLocalStudiesList() {
  return {
    type: REQUEST_LOCAL_STUDIES_LIST,
  };
}

export const RESET_LOCAL_STUDIES_LIST = "RESET_LOCAL_STUDIES_LIST";
export function resetLocalStudiesList() {
  return {
    type: RESET_LOCAL_STUDIES_LIST,
  };
}

export const RECEIVE_LOCAL_STUDIES_LIST = "RECEIVE_LOCAL_STUDIES_LIST";
export function receiveLocalStudiesList(response) {
  return {
    type: RECEIVE_LOCAL_STUDIES_LIST,
    studies: response.all_local_studies,
  };
}

export function fetchRemoteStudiesList() {
  return function (dispatch, getState) {
    let state = getState();
    let req = {
      credential: {
        username: state.userInfo.username,
        password: state.userInfo.password,
      },
    };
    console.log("GET request made for /get_remote_studies_list", req);
    dispatch(requestRemoteStudiesList());

    return axios.post(serverURL + "/get_remote_studies_list", req).then(
      (response) => {
        console.log("get_remote_studies_list", response);
        dispatch(receiveRemoteStudiesList(response.data));
      },
      (error) => {
        dispatch(resetRemoteStudiesList());
        dispatch(errorResponse(error));
      }
    );
  };
}

export const REQUEST_REMOTE_STUDIES_LIST = "REQUEST_REMOTE_STUDIES_LIST";
export function requestRemoteStudiesList() {
  return {
    type: REQUEST_REMOTE_STUDIES_LIST,
  };
}

export const RESET_REMOTE_STUDIES_LIST = "RESET_REMOTE_STUDIES_LIST";
export function resetRemoteStudiesList() {
  return {
    type: RESET_REMOTE_STUDIES_LIST,
  };
}

export const RECEIVE_REMOTE_STUDIES_LIST = "RECEIVE_REMOTE_STUDIES_LIST";
export function receiveRemoteStudiesList(response) {
  return {
    type: RECEIVE_REMOTE_STUDIES_LIST,
    studies: response.all_remote_studies,
  };
}

export function fetchSetLocalStudy(studyId) {
  return function (dispatch, getState) {
    dispatch(requestSetStudy());
    let state = getState();
    // let req = {
    //   filepath: filepath,
    //   credential: {
    //     username: state.userInfo.username,
    //     password: state.userInfo.password,
    //   },
    // };
    console.log("POST request made for /set_current_study for", studyId);
    // return axios.post(serverURL + "/set_local_study", req).then(
    //   (response) => {
    dispatch(loadStudy(studyId));
    //   },
    //   (error) => {
    //     dispatch(resetSetStudy());
    //     dispatch(errorResponse(error));
    //   }
    // );
  };
}

export function loadStudy(studyId) {
  return function (dispatch, getState) {
    // Set the protocol
    let state = getState();

    if (studyId === studyFixture.study.studyInfo.id) {
      dispatch(receiveProtocol(studyFixture.protocol));
      dispatch(
        receiveSetStudy(
          studyFixture.study,
          studyFixture.study.studyInfo.studySavePath
        )
      );
    } else {
      dispatch(
        receiveProtocol(
          state.availableStudies.localStudyInfoById[studyId].protocol
        )
      );
      dispatch(
        receiveSetStudy(
          state.availableStudies.localStudyInfoById[studyId].study,
          state.availableStudies.localStudyInfoById[studyId].study.studyInfo
            .studySavePath
        )
      );
    }

    // if (response.data["upgraded"]) {
    //   dispatch(
    //     warningResponse(
    //       "Study has been upgraded to the latest version and resaved."
    //     )
    //   );
    // }

    // if (
    //   !response.data["data_local"] &&
    //   response.data["study"].studyInfo.locked === true
    // ) {
    //   //response was unlock=False, back-end does NOT have the data for all of the samples
    //   batch(() => {
    //     dispatch(setDataLocal(false)); // change DataLocal to false
    //     dispatch(setView(viewIds.mainApp));
    //   });
    // } else if (response.data["data_local"]) {
    //response was unlock=true, back-end does have the data for all of the samples
    dispatch(setView(viewIds.mainApp)); //proceed with the app
    // } else if (
    //   !response.data["data_local"] &&
    //   response.data["study"].studyInfo.locked === false
    // ) {
    //   //response was unlock=False, back-end does NOT have the data for all of the samples
    //   batch(() => {
    //     dispatch(setDataLocal(false)); // change DataLocal to false
    //     dispatch(toggleLoadDialog()); //inform the user that the study can only be uploaded in LOCKED state becase the backend does NOT have all the sample data
    //   });
    // }
  };
}

export const REQUEST_SET_STUDY = "REQUEST_SET_STUDY";
export function requestSetStudy() {
  return {
    type: REQUEST_SET_STUDY,
  };
}

export const RESET_SET_STUDY = "RESET_SET_STUDY";
export function resetSetStudy() {
  return {
    type: RESET_SET_STUDY,
  };
}

export const RECEIVE_SET_STUDY = "RECEIVE_SET_STUDY";
export function receiveSetStudy(response, file_path) {
  let correctedSavePath = file_path.replace(/[\\]/g, "/");
  if (
    correctedSavePath.endsWith(".autosave.study") ||
    correctedSavePath.endsWith(".autosave.study.encrypt")
  ) {
    correctedSavePath = correctedSavePath.replace(".autosave", "");
  }
  return {
    type: RECEIVE_SET_STUDY,
    studyInfo: response.studyInfo,
    locations: response.locations,
    samples: response.samples,
    path: correctedSavePath,
  };
}

export function fetchSetRemoteStudy(studyId) {
  return function (dispatch, getState) {
    dispatch(requestSetStudy());
    let state = getState();
    let req = {
      studyId: studyId,
      credential: {
        username: state.userInfo.username,
        password: state.userInfo.password,
      },
    };
    console.log("POST request made for /set_remote_study for", req);
    return axios.post(serverURL + "/set_remote_study", req).then(
      (response) => {
        dispatch(loadStudy(response, "REMOTE"));
      },
      (error) => {
        dispatch(resetSetStudy());
        dispatch(errorResponse(error));
      }
    );
  };
}

export const SET_DATA_LOCAL = "SET_DATA_LOCAL";
export function setDataLocal(allDataLocal) {
  return {
    type: SET_DATA_LOCAL,
    allDataLocal,
  };
}

// check if any changes are made to the study since the last saved version
export function fetchCheckSavedStudy(filePath, prompt) {
  return function (dispatch, getState) {
    const state = getState();
    let formatedData = formatStudyData(state);
    let req = {
      filePath: filePath,
      study: formatedData["study"],
      protocol: formatedData["protocol"],
      encryption: state.studyInfo.encryption,
      credential: {
        username: state.userInfo.username,
        password: state.userInfo.password,
      },
    };
    console.log("POST request made for /check_saved_study", req);
    // return axios.post(serverURL + "/check_saved_study", req).then(
    //   (response) => {
    //     if (!response.data["saved"]) {
    //       // response was saved=False, ask user if they want to re-save the study to capture the latest changes
    //       dispatch(toggleSaveDialog());
    //     } else {
    dispatch(discardStudy(prompt)); // response was saved=True, the study can be discarded
    //     }
    //   },
    //   (error) => {
    //     dispatch(toggleSaveDialog());
    //     dispatch(errorResponse(error));
    //   }
    // );
  };
}

export const SET_ENCRYPTION = "SET_ENCRYPTION";
export function setEncryption(encryption) {
  return {
    type: SET_ENCRYPTION,
    encryption: encryption,
  };
}
export const ADD_STUDY_TO_REDUX = "ADD_STUDY_TO_REDUX";
export function addStudyToRedux(study) {
  return {
    type: ADD_STUDY_TO_REDUX,
    study: study,
  };
}
export function fetchSaveStudy(
  prompt,
  encryption,
  syncRemote = false,
  oldPath = null
) {
  return function (dispatch, getState) {
    const state = getState();
    let formatedData = formatStudyData(state);
    if (prompt !== "AUTOSAVE") {
      dispatch(requestSaveStudy());
    }
    if (prompt === null) {
      prompt = "CONTINUE";
    }

    if (!wifiEnabled) {
      syncRemote = false;
    }

    let req = {
      study: formatedData["study"],
      protocol: formatedData["protocol"],
      save_type: prompt,
      old_path: oldPath,
      encryption: encryption,
      syncRemote: syncRemote,
      credential: {
        username: state.userInfo.username,
        password: state.userInfo.password,
      },
    };
    console.log("POST request made for /save_study", req);
    // return axios.post(serverURL + "/save_study", req).then(
    //   (response) => {

    formatedData.study.studyInfo.study_filepath = "study_filepath";
    formatedData.study.studyInfo.study_info_filepath = "study_info_filepath";
    formatedData.study.studyInfo.multiple_study_files = [];
    dispatch(addStudyToRedux(formatedData));
    if (prompt === "QUIT" || prompt === "LOGOUT") {
      //       if (response.data.warning !== null) {
      //         dispatch(warningResponse(response.data.warning));
      //       } else {
      //         dispatch(successResponse(response.data.message));
      //       }

      dispatch(discardStudy(prompt));
    } else if (state.utility.saveAndQuit) {
      //       // if user chooses Save & Quite
      //       if (response.data.warning !== null) {
      //         dispatch(warningResponse(response.data.warning));
      //       } else {
      //         dispatch(successResponse(response.data.message));
      //       }
      dispatch(discardStudy("QUIT"));
    } else if (prompt !== "AUTOSAVE") {
      //       // if user chooses Save (not auto-save, don't want a flag when it happens)
      if (state.utility.dialog.studySaveDialog) {
        dispatch(toggleSaveDialog());
      }
      dispatch(receiveSaveStudy());
      //       dispatch(setEncryption(encryption));
      //       if (response.data.warning !== null) {
      //         dispatch(warningResponse(response.data.warning));
      //       } else {
      dispatch(successResponse("Study saved successfully"));
      //       }
      //     }
    }
    //   (error) => {
    //     dispatch(errorResponse(error));
    //     dispatch(resetSaveStudy());
    //   }
    // );
  };
}

export const REQUEST_SAVE_STUDY = "REQUEST_SAVE_STUDY";
export function requestSaveStudy() {
  return {
    type: REQUEST_SAVE_STUDY,
  };
}

export function formatStudyData(state) {
  //remap the studyInfoReducer to avoid unnecessary variables
  let studyInfo = {
    id: state.studyInfo.id,
    protocolId: state.studyInfo.protocolId,
    participantId: state.studyInfo.participantId,
    protocolName: state.studyInfo.protocolName,
    progress: state.studyInfo.progress,
    skinType: state.studyInfo.skinType,
    gender: state.studyInfo.gender,
    otherId: state.studyInfo.otherId,
    birthYear: state.studyInfo.birthYear,
    startedAt: state.studyInfo.startedAt,
    studyDate: state.studyInfo.studyDate,
    totalSamplesNeeded: state.studyInfo.totalSamplesNeeded,
    version: state.studyInfo.version,
    encryption: state.studyInfo.encryption,
    locked: state.studyInfo.locked,
    notes: state.studyInfo.notes,
    studyHash: state.studyInfo.studyHash,
    studySaved: state.studyInfo.studySaved,
    studySavePath: state.studyInfo.studySavePath,
    username: state.userInfo.username,
  };

  //remap the samplesReducer to avoid unnecessary variables
  let samples = {
    allIds: state.samples.allIds,
    byId: state.samples.byId,
    idByType: state.samples.idByType,
  };

  //remap the locationsReducer to avoid unnecessary variables such as selector position
  let stateLocationById = state.locations.byId;
  Object.keys(stateLocationById).forEach((location) => {
    if (stateLocationById[location].hasOwnProperty("lastViewedSample")) {
      delete stateLocationById[location]["lastViewedSample"];
    }
  });
  let locations = {
    byId: stateLocationById,
    allIds: state.locations.allIds,
  };

  return {
    study: {
      studyInfo: studyInfo,
      locations: locations,
      samples: samples,
    },
    protocol: state.protocol,
  };
}

export const RECEIVE_SAVE_STUDY = "RECEIVE_SAVE_STUDY";
export function receiveSaveStudy() {
  return {
    type: RECEIVE_SAVE_STUDY,
  };
}

export function fetchExportStudyPDF(password, savepath) {
  return function (dispatch, getState) {
    dispatch(requestExportStudyPDF());
    const state = getState();
    let formatedData = formatStudyData(state);
    let req = {
      study: formatedData["study"],
      protocol: formatedData["protocol"],
      password: password,
      savepath: savepath,
    };
    console.log("POST request made for /export_study_pdf", req);
    return axios.post(serverURL + "/export_study_pdf", req).then(
      (response) => {
        if (state.utility.dialog.exportPdfDialog) {
          dispatch(toggleExportPdfDialog());
        }
        dispatch(receiveExportStudyPDF());
        dispatch(successResponse(response.data.message));
      },
      (error) => {
        dispatch(receiveExportStudyPDF());
        dispatch(errorResponse(error));
      }
    );
  };
}

export const REQUEST_EXPORT_STUDY_PDF = "REQUEST_EXPORT_STUDY_PDF";
export function requestExportStudyPDF() {
  return {
    type: REQUEST_EXPORT_STUDY_PDF,
  };
}

export const RECEIVE_EXPORT_STUDY_PDF = "RECEIVE_EXPORT_STUDY_PDF";
export function receiveExportStudyPDF() {
  return {
    type: RECEIVE_EXPORT_STUDY_PDF,
  };
}

export function fetchExportStudyCSV(studyIds, savePath) {
  return function (dispatch, getState) {
    dispatch(requestExportStudyCSV());
    const state = getState();
    // There is no need to pass the entire study data object. A new object is formed with only the required information.
    // The new object maintains the study data dict structure
    let studyInformation = {};
    studyIds.forEach((studyId) => {
      if (
        Object.keys(state.availableParticipants.reviewStudies).includes(studyId)
      ) {
        let samplesById = {};
        Object.keys(
          state.availableParticipants.reviewStudies[studyId].samples.byId
        ).forEach((sampleId) => {
          let sample =
            state.availableParticipants.reviewStudies[studyId].samples.byId[
              sampleId
            ];
          if (sample.type === "BMODE") {
            samplesById[sampleId] = {
              id: sampleId,
              type: sample.type,
              topSurface: sample.topSurface,
              bottomSurface: sample.bottomSurface,
              locationId: sample.locationId,
              includeInStudy: sample.includeInStudy,
            };
          } else if (csiTypes.includes(sample.type)) {
            samplesById[sampleId] = {
              id: sampleId,
              type: sample.type,
              shearWaveSpeed: sample.shearWaveSpeed,
              zValue: sample.zValue,
              roiDz: sample.roiDz,
              locationId: sample.locationId,
              includeInStudy: sample.includeInStudy,
            };
          }
        });
        studyInformation[studyId] = {
          studyInfo: {
            id: studyId,
            studyDate:
              state.availableParticipants.reviewStudies[studyId].studyInfo
                .studyDate,
            participantId:
              state.availableParticipants.reviewStudies[studyId].studyInfo
                .participantId,
          },
          samples: { byId: samplesById },
        };
      } else if (state.studyInfo.id === studyId) {
        let samplesById = {};
        Object.keys(state.samples.byId).forEach((sampleId) => {
          let sample = state.samples.byId[sampleId];
          if (sample.type === "BMODE") {
            samplesById[sampleId] = {
              id: sampleId,
              type: sample.type,
              topSurface: sample.topSurface,
              bottomSurface: sample.bottomSurface,
              locationId: sample.locationId,
              includeInStudy: sample.includeInStudy,
            };
          } else if (csiTypes.includes(sample.type)) {
            samplesById[sampleId] = {
              id: sampleId,
              type: sample.type,
              shearWaveSpeed: sample.shearWaveSpeed,
              zValue: sample.zValue,
              roiDz: sample.roiDz,
              locationId: sample.locationId,
              includeInStudy: sample.includeInStudy,
            };
          }
        });
        studyInformation[state.studyInfo.id] = {
          studyInfo: {
            id: state.studyInfo.id,
            participantId: state.studyInfo.participantId,
          },
          samples: { byId: samplesById },
        };
      }
    });

    let req = {
      studies: studyInformation,
      save_filepath: savePath,
    };

    console.log("POST request made for /export_study_csv", req);
    return axios.post(serverURL + "/export_study_csv", req).then(
      (response) => {
        if (state.utility.dialog.exportCsvDialog) {
          dispatch(toggleExportCsvDialog());
        }
        dispatch(receiveExportStudyCSV());
        dispatch(successResponse(response.data.message));
      },
      (error) => {
        dispatch(receiveExportStudyCSV());
        dispatch(errorResponse(error));
      }
    );
    // return axios.get(serverURL + "/get_available_participants").then(
    //   (response) => {
    //     dispatch(receiveAvailableParticipants(response.data));
    //   },
    //   (error) => dispatch(errorResponse(error))
    // );
  };
}

export const REQUEST_EXPORT_STUDY_CSV = "REQUEST_EXPORT_STUDY_CSV";
export function requestExportStudyCSV() {
  return {
    type: REQUEST_EXPORT_STUDY_CSV,
  };
}

export const RECEIVE_EXPORT_STUDY_CSV = "RECEIVE_EXPORT_STUDY_CSV";
export function receiveExportStudyCSV() {
  return {
    type: RECEIVE_EXPORT_STUDY_CSV,
  };
}

export const REQUEST_EXPORT_STUDIES = "REQUEST_EXPORT_STUDIES";
export function requestExportStudies() {
  return {
    type: REQUEST_EXPORT_STUDIES,
  };
}

export const RECEIVE_EXPORT_STUDIES = "RECEIVE_EXPORT_STUDIES";
export function receiveExportStudies() {
  return {
    type: RECEIVE_EXPORT_STUDIES,
  };
}

export function fetchExportStudies(usb, studies, exportLog) {
  return function (dispatch, getState) {
    dispatch(requestExportStudies());
    const state = getState();
    let req = {
      studies: studies,
      usb: usb,
      exportLog: exportLog,
      credential: {
        username: state.userInfo.username,
        password: state.userInfo.password,
      },
    };
    console.log("POST request made for /export_studies", req);
    return axios.post(serverURL + "/export_studies", req).then(
      (response) => {
        if (state.utility.dialog.exportStudiesDialog) {
          dispatch(toggleExportStudiesDialog());
        }
        dispatch(receiveExportStudies());
        dispatch(successResponse(response.data.message));
      },
      (error) => {
        dispatch(receiveExportStudies());
        dispatch(errorResponse(error));
      }
    );
  };
}

export function discardStudyFile(studyFilepath, studySaved, studyId) {
  return function (dispatch) {
    let req = {
      studyFilepath: studyFilepath,
      studySaved: studySaved,
      studyId: studyId,
    };
    console.log("POST request made for /discard_study_file", req);
    return axios.post(serverURL + "/discard_study_file", req).then(
      (response) => {},
      (error) => {
        dispatch(errorResponse(error));
      }
    );
  };
}

export const REQUEST_SYNC_STUDIES = "REQUEST_SYNC_STUDIES";
export function requestSyncStudies() {
  return {
    type: REQUEST_SYNC_STUDIES,
  };
}

export const RECEIVE_SYNC_STUDIES = "RECEIVE_SYNC_STUDIES";
export function receiveSyncStudies() {
  return {
    type: RECEIVE_SYNC_STUDIES,
  };
}
export function fetchPushStudyToRemote(studies, exportLog) {
  return function (dispatch, getState) {
    dispatch(requestSyncStudies());
    const state = getState();
    let req = {
      studies: studies,
      exportLog: exportLog,
      credential: {
        username: state.userInfo.username,
        password: state.userInfo.password,
      },
    };

    console.log("POST request made for /push_study_to_remote", req);
    return axios.post(serverURL + "/push_study_to_remote", req).then(
      (response) => {
        if (state.utility.dialog.syncStudiesDialog) {
          dispatch(toggleSyncStudiesDialog());
        }
        dispatch(receiveSyncStudies());
        if (response.data.skipped_study_ids.length === 0) {
          dispatch(successResponse(response.data.message));
        } else {
          dispatch(
            warningResponse(
              "Following studies were not uploaded to cloud because the study is either already on the cloud or it was not found on local device: " +
                response.data.skipped_study_ids
            )
          );
        }
      },
      (error) => {
        dispatch(receiveSyncStudies());
        dispatch(errorResponse(error));
      }
    );
  };
}
export function fetchCheckUpdate() {
  return function (dispatch) {
    console.log("GET request made for /check_update/");

    return axios.get(serverURL + "/check_update").then(
      (response) => {
        // console.log(response);
      },
      (error) => {
        dispatch(errorResponse(error));
      }
    );
  };
}
